import React, { useState, useEffect, useRef, useContext } from "react";
import { NavLink, useLocation, matchPath } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { logout } from "../services/authService";
import {
	subscribeToLandscapeChange,
	isLandscape,
	unsubscribeFromLandscapeChange,
} from "../services/mobileService";
import { GenericModal } from "./common/GenericModal";
import { isOnChartScreen } from "../services/summaryReportsService";
import { NotificationBadge } from "../components/common/NotificationBadge";
import { DashboardContext } from "../contexts/dashboardContext";

export const NavBarMain = ({ isCostsEnabled, onCostsOffClick }) => {
	const location = useLocation();
	const [isShowingLockupModal, setIsShowingLockupModal] = useState(false);

	const { dueReportsCount } = useContext(DashboardContext);

	const { instance, accounts } = useMsal();

	const handleLockout = () => {
		setIsShowingLockupModal(false);
		logout(instance, accounts[0]);
	};

	const isMounted = useRef(false);

	const [hide, setHide] = useState(false);

	const handleLandscapeChange = (result) => {
		if (isMounted.current === true) {
			setHide(result && isOnChartScreen());
		}
	};

	const isActive = (path) => matchPath(location.pathname, { path: path });

	useEffect(() => {
		isMounted.current = true;
		subscribeToLandscapeChange("NavBarMain", handleLandscapeChange);

		isLandscape().then(handleLandscapeChange);

		return () => {
			isMounted.current = false;
			unsubscribeFromLandscapeChange("NavBarMain");
		};
	}, []);

	if (hide) {
		return null;
	}

	return (
		<>
			<ul
				className={
					"flex-shrink grid grid-cols-4 max-w-2xl mx-auto text-center font-bold"
				}
			>
				<li className={"bottomNav"}>
					<NavLink
						to="/dashboard/todo"
						className={(isActive) => {
							return `text-black relative ${
								isActive ? "font-bold" : "font-normal"
							}`;
						}}
					>
						<NotificationBadge
							count={dueReportsCount.todo}
							classes={"absolute z-10 top-0 ml-2 mx-auto"}
						/>
						<div
							className={`ss-icon text-3xl relative z-0 ${
								isActive("/dashboard/todo") && "ss-glyphish-filled"
							}`}
						>
							&#x2302;
						</div>
						<span>To-dos</span>
					</NavLink>
				</li>

				<li className={"bottomNav"}>
					<NavLink
						to="/dashboard/summary"
						className={(isActive) => {
							return `text-black ${isActive ? "font-bold" : "font-normal"}`;
						}}
					>
						<div
							className={`ss-icon text-3xl ${
								isActive("/dashboard/summary") && "ss-glyphish-filled"
							}`}
						>
							&#x1F5E0;
						</div>
						<span>Summary</span>
					</NavLink>
				</li>

				<li className={"bottomNav"}>
					{isCostsEnabled ? (
						<>
							<NavLink
								to="/dashboard/costs"
								className={(isActive) => {
									return `text-black ${isActive ? "font-bold" : "font-normal"}`;
								}}
							>
								<div
									className={`ss-icon text-3xl ${
										isActive("/dashboard/costs") && "ss-glyphish-filled"
									}`}
								>
									&#xE545;
								</div>
								<span>Costs</span>
							</NavLink>
						</>
					) : (
						<>
							<button
								onClick={onCostsOffClick}
								className={"text-black font-normal"}
							>
								<div className="ss-icon text-3xl">&#xE545;</div>
								<span>Costs</span>
							</button>
						</>
					)}
				</li>

				<button
					className={`link bottomNav text-black font-normal`}
					onClick={() => setIsShowingLockupModal(true)}
				>
					<div>
						<div
							className={`ss-icon text-3xl ss-door ${
								isShowingLockupModal ? "ss-glyphish-filled" : ""
							}`}
						></div>
					</div>
					<span
						className={`${isShowingLockupModal ? "font-bold" : "font-normal"}`}
					>
						Exit
					</span>
				</button>
			</ul>

			<GenericModal
				show={isShowingLockupModal}
				onClose={() => setIsShowingLockupModal(false)}
				onNext={handleLockout}
				title="Exit"
				text={"Are you sure you want to exit?"}
				backText={"No"}
				nextText={"Yes"}
				currentTheme
			/>
		</>
	);
};
